/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DisbursementPaymentMethodType,
  DisbursementPaymentMethodType$inboundSchema,
  DisbursementPaymentMethodType$outboundSchema,
} from "./disbursementpaymentmethodtype.js";
import {
  PayoutRecipient,
  PayoutRecipient$inboundSchema,
  PayoutRecipient$Outbound,
  PayoutRecipient$outboundSchema,
} from "./payoutrecipient.js";

export type PaymentLinkPayoutDetailsUpdate = {
  /**
   * A list of payment methods that should be supported for this payment link.
   */
  allowedMethods?: Array<DisbursementPaymentMethodType> | undefined;
  /**
   * Specify the intended recipient of the payout.
   *
   * @remarks
   * Either `email` or `phone` must be specified, but not both.
   *
   * This information will be used to authenticate the end user when they follow the payment link.
   */
  recipient?: PayoutRecipient | undefined;
  /**
   * Optional free-form metadata for the transfer.
   */
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const PaymentLinkPayoutDetailsUpdate$inboundSchema: z.ZodType<
  PaymentLinkPayoutDetailsUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  allowedMethods: z.array(DisbursementPaymentMethodType$inboundSchema)
    .optional(),
  recipient: PayoutRecipient$inboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});
/** @internal */
export type PaymentLinkPayoutDetailsUpdate$Outbound = {
  allowedMethods?: Array<string> | undefined;
  recipient?: PayoutRecipient$Outbound | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const PaymentLinkPayoutDetailsUpdate$outboundSchema: z.ZodType<
  PaymentLinkPayoutDetailsUpdate$Outbound,
  z.ZodTypeDef,
  PaymentLinkPayoutDetailsUpdate
> = z.object({
  allowedMethods: z.array(DisbursementPaymentMethodType$outboundSchema)
    .optional(),
  recipient: PayoutRecipient$outboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});

export function paymentLinkPayoutDetailsUpdateToJSON(
  paymentLinkPayoutDetailsUpdate: PaymentLinkPayoutDetailsUpdate,
): string {
  return JSON.stringify(
    PaymentLinkPayoutDetailsUpdate$outboundSchema.parse(
      paymentLinkPayoutDetailsUpdate,
    ),
  );
}
export function paymentLinkPayoutDetailsUpdateFromJSON(
  jsonString: string,
): SafeParseResult<PaymentLinkPayoutDetailsUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaymentLinkPayoutDetailsUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaymentLinkPayoutDetailsUpdate' from JSON`,
  );
}
